<template>
    <b-container class="without-spacing">
        <h2 class="header-bottom-margin">{{ $t('title') }}</h2>

        <b-alert fade v-model="message.visible" :variant="message.type" dismissible class="alert">
            {{ message.text }}
        </b-alert>

        <template v-if="isNewMode">
            <p v-html="$t('subtitle-new-mode')"></p>

            <validation-observer v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(sendEmail)">
                    <validation-provider name="email"
                                         rules="required|email"
                                         v-slot="validationContext">
                        <b-form-group id="user-email-group" :label="$t('user-email-label')" label-for="user-email"
                                      :invalid-feedback="validationContext.errors[0]">
                            <b-form-input id="user-email"
                                          v-model="email"
                                          :state="getValidationState(validationContext)"
                                          :disabled="actionsDisabled">
                            </b-form-input>
                        </b-form-group>
                    </validation-provider>

<!--                    &lt;!&ndash; <vue-recaptcha v-if="isRecaptchaEnabled"-->
<!--                                   ref="recaptcha"-->
<!--                                   class="recaptcha"-->
<!--                                   :class="recaptchaState === false ? 'error' : null"-->
<!--                                   :sitekey="recaptchaSiteKey"-->
<!--                                   @verify="saveRecaptchaToken"-->
<!--                                   @expired="resetRecaptcha"-->
<!--                                   :loadRecaptchaScript="true">-->
<!--                    </vue-recaptcha> &ndash;&gt;-->

                    <dp-button type="submit" :disabled="actionsDisabled">{{ $t('send-email-action') }}</dp-button>
                    <label class="action-divider">{{ $t('action-divider') }}</label>
                    <dp-button ghost @click.prevent="goToLogin">{{ $t('login-action') }}</dp-button>
                </b-form>
            </validation-observer>
        </template>

        <template v-if="isWaitMode">
            <div class="info-block">
                <div>
                    <dp-icon name="check" class="checked-icon mr-2" width="32" height="32" :sensitive="false"></dp-icon>
                </div>
                <div>
                    <p>{{ $t('subtitle-wait-mode') }}</p>
                </div>
            </div>
            <b-link class="back-to-user-login" :to="{name: 'login'}" replace>
                <dp-icon name="arrow-left" class="mr-2" width="16" height="16" :sensitive="false"></dp-icon>
                <span>{{ $t('back-to-login-action') }}</span>
            </b-link>
        </template>

        <template v-if="isEditMode">
            <p>{{ $t('subtitle-edit-mode') }}</p>

            <validation-observer v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(save)">
                    <validation-provider name="name"
                                         rules="required"
                                         v-slot="validationContext">
                        <b-form-group id="user-name-group" :label="$t('user-name-label')" label-for="user-name"
                                      :invalid-feedback="validationContext.errors[0]">
                            <b-form-input id="user-name"
                                          v-model="user.name"
                                          :state="getValidationState(validationContext)"
                                          :disabled="actionsDisabled">
                            </b-form-input>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider name="password"
                                         rules="required|min:8|confirmed:passwordConfirm"
                                         v-slot="validationContext">
                        <b-form-group id="user-password-group" label-for="user-password"
                                      :invalid-feedback="validationContext.errors[0]">
                            <template v-slot:label>
                                {{ $t('user-password-label') }}
                                <b-icon v-if="isVisiblePassword" @click="isVisiblePassword = !isVisiblePassword"
                                        icon="eye-slash-fill"
                                        class="password-visibility-icon"></b-icon>
                                <b-icon v-else icon="eye-fill" @click="isVisiblePassword = !isVisiblePassword"
                                        class="password-visibility-icon"></b-icon>
                            </template>
                            <b-form-input id="user-password"
                                          v-model="user.password"
                                          :type="passwordFieldType"
                                          :state="getValidationState(validationContext)"
                                          :disabled="actionsDisabled">
                            </b-form-input>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider name="passwordConfirm"
                                         vid="passwordConfirm"
                                         rules="required|min:8"
                                         v-slot="validationContext">
                        <b-form-group id="user-password-confirm-group" :label="$t('user-password-confirm-label')"
                                      label-for="user-password-confirm"
                                      :invalid-feedback="validationContext.errors[0]">
                            <b-form-input id="user-password-confirm"
                                          v-model="user.passwordConfirm"
                                          :type="passwordFieldType"
                                          :state="getValidationState(validationContext)"
                                          :disabled="actionsDisabled">
                            </b-form-input>
                        </b-form-group>
                    </validation-provider>

                    <dp-button type="submit" class="save-btn" :disabled="actionsDisabled">
                        {{ $t('save-action') }}
                    </dp-button>
                </b-form>
            </validation-observer>
        </template>

    </b-container>
</template>

<script>
import DpIcon from '@/components/icon/dp-icon'
import DpButton from '@/components/button/dp-button'
// import VueRecaptcha from 'vue-recaptcha'
import ValidationMixin from '@/mixins/validation-mixin'
import ErrorMixin from '@/mixins/error-mixin'
import UserService from '@/services/user-service'

const STATUS = {
  NEW: 'NEW',
  WAIT: 'WAIT',
  EDIT: 'EDIT'
}

export default {
  name: 'registration',
  components: {
    DpIcon,
    DpButton
    // VueRecaptcha
  },
  mixins: [ValidationMixin, ErrorMixin],
  data() {
    return {
      status: null,
      email: null,
      user: {
        code: null,
        name: null,
        password: null,
        passwordConfirm: null
      },
      actionsDisabled: false,
      isVisiblePassword: false,
      message: {
        visible: false,
        type: 'danger',
        text: null
      }
      // recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      // recaptchaToken: null,
      // recaptchaState: null
    }
  },
  computed: {
    isNewMode() {
      return this.status === STATUS.NEW
    },
    isWaitMode() {
      return this.status === STATUS.WAIT
    },
    isEditMode() {
      return this.status === STATUS.EDIT
    },
    passwordFieldType() {
      return this.isVisiblePassword ? 'text' : 'password'
    }
    // <!-- isRecaptchaEnabled() {
    //   return !!this.recaptchaSiteKey
    // } -->
  },
  mounted() {
    if (this.$route.params.code) {
      this.status = STATUS.EDIT
    } else {
      this.status = STATUS.NEW
    }
    this.user.code = this.$route.params.code
  },
  methods: {
    sendEmail() {
      this.message.visible = false

      // <!-- if (!this.recaptchaToken && this.isRecaptchaEnabled) {
      //   this.recaptchaState = false
      //   return
      // } -->

      this.actionsDisabled = true
      UserService.signup(this.email, this.$i18n.locale).then((_) => {
        this.status = STATUS.WAIT
      }).catch((error) => {
        this.message.text = this.getErrorMessage(error)
        this.message.visible = true
      }).finally(() => {
        this.actionsDisabled = false
        // this.resetRecaptcha()
      })
    },
    save() {
      this.message.visible = false
      this.actionsDisabled = true

      UserService.confirm(this.user.code, this.user.name, this.user.password).then((_) => {
        this.$router.replace({
          name: 'login'
        })
      }).catch((error) => {
        this.message.text = this.getErrorMessage(error)
        this.message.visible = true
      }).finally(() => {
        this.actionsDisabled = false
      })
    },
    goToLogin() {
      this.$router.push({
        name: 'login'
      })
    }
    // <!-- saveRecaptchaToken(token) {
    //   this.recaptchaToken = token
    //   this.recaptchaState = true
    // },
    // resetRecaptcha() {
    //   if (this.isRecaptchaEnabled) {
    //     if (this.$refs.recaptcha) {
    //       this.$refs.recaptcha.reset()
    //     }
    //     this.recaptchaToken = null
    //     this.recaptchaState = null
    //   }
    // } -->
  }
}
</script>

<style scoped lang="scss">
.alert {
  width: fit-content;
  min-width: 282px;
}

#user-email-group {
  margin-bottom: 40px !important;
}

a.back-to-user-login span {
  font-weight: $--font-weight-regular !important;
  font-size: $--font-size-small !important;
  line-height: 21px;
  letter-spacing: -0.5px;
}

.action-divider {
  margin-left: 14px;
  margin-right: 14px;
  font-weight: $--font-weight-medium;
}

.checked-icon {
  fill: $--color-green-300;
}

.info-block {
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
}

.save-btn {
  margin-top: 42px !important;
}

.password-visibility-icon {
  float: right;
  font-size: $--font-size-medium-base;
  cursor: pointer;
}
</style>

<style lang="scss">
.recaptcha {
  margin-bottom: 32px;

  &.error {
    iframe {
      border: 2px solid $--color-red-300 !important;
    }
  }
}
</style>

<i18n>
{
    "en": {
        "title": "Register",
        "subtitle-new-mode": "Enter your email address to register in the system.<br>You will receive an email containing a link to register.",
        "subtitle-wait-mode": "Please check your email. A link to register in the system is sent to the email address you entered.",
        "subtitle-edit-mode": "Fill in the fields below to complete registration.",
        "send-email-action": "Register",
        "save-action": "Registration"
    },
    "ru": {
        "title": "Зарегистрироваться",
        "subtitle-new-mode": "Введите электронный адрес, чтобы зарегистрироваться в системе. Вы получите ссылку для регистрации на электронную почту.",
        "subtitle-wait-mode": "Пожалуйста, проверьте электронную почту. Письмо со ссылкой для регистрации в системе отправлено на указанный электронный адрес.",
        "subtitle-edit-mode": "Введите ваше имя и задайте пароль.",
        "send-email-action": "Зарегистрироваться",
        "save-action": "Зарегистрироваться",
        "user-password-confirm-label": "Подтвердите пароль:"
    }
}
</i18n>
